var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apollo-query',{ref:"query",staticClass:"page-serial-number",attrs:{"query":require('@/graphql/RecaptureAIAudit.graphql'),"fetchPolicy":"network-only"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_result = ref.result;
var error = ref_result.error;
var data = ref_result.data;
var isLoading = ref.isLoading;
var query = ref.query;
return [(isLoading)?_c('spinner'):(error)?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"alert alert-danger"},[_vm._v(" "+_vm._s(error)+" ")])])])]:(data)?[_c('recapture-a-i-check',{attrs:{"audit":data.recaptureAIAudit},on:{"saved":_vm.next}})]:_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }